import Api from "./http";

// Shared sign-out used by the navbar dropdown and the Profile page.
export const logout = async () => {
  try {
    await Api.post("/web/logout");
  } catch { }
  localStorage.clear();
  window.location.href = "/";
};
